import Header from './../components/header/Header';
import Skill from '../components/skill/Skill'
import {skills} from '../helpers/skillsList'

const Home = () => {
  return (
    <>
      <Header  
              title="Hi, my name is"
              subtitle="Elena"
              subtitle_2="and I'm a"
              text="Hi! I am an aspiring web developer. I am recently graduated as a programmer and am passionate about creating and developing websites. My goal is to use my knowledge and skills to develop high-quality and functional web applications, as well as to continue growing and evolving in this field."
              typedTextStrings={["Web developer", "Designer", "Photographer"]}
              link="/projects"
              button_text="Websites that stand out"
              />

      <main>
        <section className="services section">
          <div className="container">
            <h2 className="title-2">My <span className='accent'>services</span></h2>

            <div className="services__cards">
              <div className="services__cards-inner">

                {skills.map((skill, index) => (
                  <Skill
                        key={index} 
                        title_skill={skill.title_skill}
                        capacity_1={skill.capacity_1}
                        capacity_2={skill.capacity_2}
                        capacity_3={skill.capacity_3}
                        capacity_4={skill.capacity_4}
                        cta={skill.cta}
                        link={skill.link}

                  />
                ))}

              </div>
            </div>

          {/* <ul className="content-list">
            <li className="content-list__item">
              <h2 className="title-2">Frontend</h2>
              <p>
                JavaScript, ReactJS, HTML, CSS, NPM,
                BootStrap, SASS
              </p>
            </li>
            <li className="content-list__item">
              <h2 className="title-2">Backend</h2>
              <p>NodeJS, MySQL, MongoDB, PHP</p>
            </li>
          </ul> */}
          </div>
        </section>
      </main>
    </>
  );
};

export default Home;
